<app-adminav></app-adminav>
<div class="container-fluid">
    <div class="col-lg-12 mt-5">
        <h4>Listado de Productos Torreón Market</h4>
        <hr>
        <div class="form-group col-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1"><i class="fa fa-search"></i></span>
                </div>
                <input type="text" class="form-control" [(ngModel)]="filterProducto" name="filterProducto" placeholder="Buscar producto..." aria-label="Username" aria-describedby="basic-addon1" autocomplete="off">
                <!-- <button (click)="arreglarPrecios()" >Arreglar</button> -->
            </div>
        </div>
        <table class="table mt-3 animated fadeIn faster">
            <thead class="thead-dark">
                <tr>
                    <th></th>
                    <th>Producto</th>
                    <th>Estado</th>
                    <th>Categoría</th>
                    <th>Presentación</th>
                    <th>Cantidad</th>
                    <th>Descuento</th>
                    <th>Precio</th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody class="text-left">
                <tr *ngFor="let producto of productos  | filter:filterProducto">
                    <td><img [src]="producto.imagen" class="img-fluid" alt="Responsive image" width="80"></td>
                    <td style="width: 150px;">{{producto.nombre}}</td>
                    <td><b>{{producto.estado}}</b></td>
                    <td>{{producto.categoria[0]}}</td>
                    <td>{{producto.presentacion}}</td>
                    <td>{{producto.cantidad}}</td>
                    <td>{{producto.descuento}}%</td>
                    <td>${{producto.precio | number}}</td>
                    <td>
                        <button *ngIf="producto.estado == 'Activado'" class="btn btn-dark mr-1" title="Desactivar" (click)="desactivaProducto(producto.id)">
                            <i class="fa fa-power-off"></i>
                        </button>
                        <button *ngIf="producto.estado == 'Desactivado'" class="btn btn-success mr-1" title="Activar" (click)="activaProducto(producto.id)">
                            <i class="fa fa-power-off"></i>
                        </button>
                        <button class="btn btn-info mr-1" title="Editar" [routerLink]="['/editar', producto.id]">
                            <i class="fa fa-pencil"></i>
                        </button>
                        <button class="btn btn-danger" title="Eliminar" (click)="borrarProducto(producto)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
